import { render } from "./GoodsDetail.vue?vue&type=template&id=6fb72bf6"
import script from "./GoodsDetail.vue?vue&type=script&lang=js"
export * from "./GoodsDetail.vue?vue&type=script&lang=js"

import "./GoodsDetail.vue?vue&type=style&index=0&id=6fb72bf6&lang=scss"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__